export const GET_FILTER_USER = 'GET_FILTER_USER'
export const GET_FILTER_USER_ERR = 'GET_FILTER_USER_ERR'
export const RESET_FILTER_USER = 'RESET_FILTER_USER'